import Plyr from "plyr";
import PhotoSwipe from "photoswipe";

document.addEventListener("DOMContentLoaded", () => {
  const galleryElement = document.getElementById("media-showcase-gallery");
  if (!galleryElement) {
    return;
  }

  let activePlyrInstance = null; // To keep track of the current video player

  const destroyActivePlayer = () => {
    if (activePlyrInstance) {
      try {
        activePlyrInstance.destroy();
        activePlyrInstance = null;
      } catch (e) {
        console.error("Error destroying Plyr instance:", e);
      }
    }
  };

  galleryElement.addEventListener("click", (e) => {
    const clickedItem = e.target.closest(".showcase-grid-item");
    if (!clickedItem) {
      return;
    }
    e.preventDefault();

    const items = Array.from(
      galleryElement.querySelectorAll(".showcase-grid-item")
    );
    const clickedIndex = items.findIndex((item) => item === clickedItem);

    const dataSource = items
      .map((item) => {
        if (item.classList.contains("showcase-grid-item--image")) {
          // Standard image slide for PhotoSwipe
          return {
            src: item.href,
            width: parseInt(item.dataset.pswpWidth, 10),
            height: parseInt(item.dataset.pswpHeight, 10),
            type: "image",
          };
        } else if (item.classList.contains("showcase-grid-item--video")) {
          // Custom HTML slide for video
          const videoUrl = item.dataset.videoUrl;
          return {
            html: `<div class="pswp__video-container"><div class="plyr__video-embed js-plyr-player"><iframe src="${videoUrl}?origin=https://player.vimeo.com&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1" allowfullscreen allowtransparency allow="autoplay"></iframe></div></div>`,
            type: "video",
          };
        }
        return null;
      })
      .filter(Boolean);

    const pswp = new PhotoSwipe({
      dataSource: dataSource,
      index: clickedIndex,
      pswpModule: PhotoSwipe, // Pass the PhotoSwipe module
    });

    // Event: When a slide becomes active
    pswp.on("change", () => {
      destroyActivePlayer(); // Destroy previous player if it exists

      const currentSlide = pswp.currSlide;
      if (currentSlide.data.type === "video") {
        const playerWrapper =
          currentSlide.content.element.querySelector(".js-plyr-player");
        if (playerWrapper) {
          activePlyrInstance = new Plyr(playerWrapper);
          // Attempt to play the video automatically when the slide is shown
          setTimeout(() => {
            if (activePlyrInstance) {
              activePlyrInstance.play();
            }
          }, 300); // Small delay to ensure the player is ready
        }
      }
    });

    // Event: When the lightbox is closed
    pswp.on("close", () => {
      destroyActivePlayer();
    });

    pswp.init();
  });
});
